<button
  mat-icon-button
  class="button button--icon"
  [ngClass]="{ active: active, disabled: disabled, 'button--outline': hasBorder }"
  [matTooltip]="tooltip"
  [style.width.px]="size"
  [style.height.px]="size"
  [matTooltipPosition]="tooltipPosition"
  [attr.aria-label]="ariaLabel"
  matTooltipClass="dark-tooltip"
  [attr.data-cy]="dataCy"
  (click)="clickHandler()">
  @if (!isLoading) {
    @if (icon) {
      <lib-icon [icon]="icon" class="icon" [ngClass]="iconClass"></lib-icon>
    }
    @if (iconUrl) {
      <lib-svg-icon class="icon" [ngClass]="iconClass" [url]="iconUrl"></lib-svg-icon>
    }
    <ng-content></ng-content>
    @if (counter) {
      <div class="button-badge" [attr.data-cy]="dataCy + '-count'">
        {{ counter > 9 ? '9+' : counter }}
      </div>
    }
  } @else {
    <mat-spinner color="primary" [diameter]="16"></mat-spinner>
  }

</button>
